import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7ed251a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", {
    class: "msg-menu",
    id: 'msg-menu-view-' + _ctx.name,
    style: {"display":"block !important"}
  }, [
    _withDirectives(_createElementVNode("div", {
      class: "msg-menu-bg",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeMsgMenu()))
    }, null, 512), [
      [_vShow, _ctx.data.show]
    ]),
    _createVNode(_component_Card, {
      class: _normalizeClass(_ctx.data.show ? 'menu show' : 'menu'),
      style: _normalizeStyle(`margin-left:${_ctx.data.point.x}px;margin-top:${_ctx.data.point.y}px;`)
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          id: 'msg-menu-body-' + _ctx.name
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 8, _hoisted_2), [
          [_vShow, !_ctx.custonBody]
        ]),
        (_ctx.custonBody)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.custonBody, (item) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "item",
                onClick: ($event: any) => (_ctx.closeMsgMenu(item.id)),
                key: 'msg-menu-body-' + item.id
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: item.icon
                }, null, 8, ["icon"]),
                _createElementVNode("a", null, _toDisplayString(item.name), 1)
              ], 8, _hoisted_3)), [
                [_vShow, _ctx.data.list && _ctx.data.list.includes(item.id)]
              ])
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class", "style"])
  ], 8, _hoisted_1))
}